import React, { useState, useEffect } from 'react';
import { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, Link, useHistory } from "react-router-dom";
import './App.css';
import axios from 'axios';
import Loader from './Loader';
import { api_url } from './Constants';
import logo from './assets/images/logo.png';

const Home = () => {
  const [value, setValue] = useState('');
  const [languages, setLanguage] = useState([]);
  const [Id, setId] = useState(0);
  const [langId, setLangId] = useState(0);
  const [isLoader, setLoader] = useState(false);
  const history = useHistory();
  
  useEffect(() => {
    loadLanguage();
    getSelectedId();
  },[]);

  const getSelectedId = () => {
    setId(0);
    setLangId(localStorage.getItem('languageId'));
  }

  const loadLanguage = async () => {
    setLoader(true);
    const result = await axios.get(api_url+`api/getalllanguages`);
    console.log(result.data);
    setLanguage(result.data);
    setLoader(false);
  }

  const handleClick = event => {
    setId(event.target.dataset.value);
    //if(Id != 0) {
      setLangId(0);
      localStorage.setItem('languageId',event.target.dataset.value);
      localStorage.setItem('language',event.target.dataset.lang);
      //setId(localStorage.setItem('languageId',Id));
      let path = `/list`; 
      history.push(path);
    //}
  }

  
  
  return (
    <div>
        <div className="container top-header sticky-top box-shadow">
          <img src={logo} style={{width: "141px"}} alt="logo"/>
            <Link to="/rechoose_language">
              <button title="Choose Language" className="float-right lng_btn">
              <i className="fa fa-language" aria-hidden="true"></i></button></Link>
              <h4 className="text-center">Select Language</h4>
        </div>

      <div className="container-fuild">
      <div className="container select-language">
        <div className="">
          <div className="alert alert-secondary pt-4" role="alert">
          Please select a language to browse the library.
          </div>
        </div>
        <form className="form-inline my-2 my-lg-0">
          <input
            className="form-control mr-sm-2 mb-2"
            type="search"
            placeholder="Search"
            aria-label="Search"
            style={{width: '100%'}}
            value={value}
            onChange={e => setValue(e.target.value)}
          />
        </form>

      <ul className="list-group list-group-flush">
        {isLoader === true &&
            <Loader /> 
        }
        {languages
          .filter(item => {
            if (!value) return true
            if (item.captionInEnglish.toLowerCase().includes(value) || item.captionInNative.toLowerCase().includes(value) || item.captionInEnglish.includes(value) || item.captionInEnglish.toUpperCase().includes(value)){
              return true
            }
          })
          .map(item => (
            <li className="list-group-item language" data-lang={item.captionInEnglish} data-value={item.languageID} onClick={handleClick}>
             
                <span className="dot pt-1 mr-2">{item.captionInEnglish.charAt(0)}</span> {item.captionInEnglish} ( {item.captionInNative} )
                
                { item.languageID === Id &&
                  <i
                  className="fa fa-check-circle fa-2x pull-right"
                  style={{color: '#d22129'}}
                  ></i>

                }
            </li>
          ))
        }

      </ul>
        <Link to="/list" className="btn btn-danger btn-block">
          Continue
        </Link>
      </div>
    </div>
        
    </div>

  );
};
  
  export default Home;